export function log(data, action) {
  if (debug_vars && debug_vars.currentUserID) {
    data = 'User with ID: ' + debug_vars.currentUserID + '; ' + data;
    $.post('https://pyramidplus.webblandskapet.se/debug/', { company: 'artwood', data: data, action: action });
  }
}